import React from 'react';
import { AccessStatus } from '../../services/dtos/article/article.dto';
import LoanWaiverLimitView from './LoanWaiver/LoanWaiverLimitView/LoanWaiverLimitView';
import ArticleLimitView from './ArticleLimit/ArticleLimitView/ArticleLimitView';
import { ArticlePermissions } from '../../models';
import { LockedContentView } from '../LockedContent';
import { getHeaderTitle } from './LockedArticle/lockedArticleUtils';
import { LockedArticleContent } from './LockedArticle/LockedArticleContent';

interface NonAccessibleContentProps {
  articlePermissions: ArticlePermissions;
  setConfirmQuotaUse?: (value: boolean) => void;
  setConfirmLoanWaiver?: (value: boolean) => void;
  isCompact?: boolean;
}

const RestrictedArticleView = ({
  articlePermissions,
  setConfirmQuotaUse,
  setConfirmLoanWaiver,
  isCompact,
}: NonAccessibleContentProps): React.ReactElement | null => {
  switch (articlePermissions.accessStatus) {
    case AccessStatus.granted:
      return null;
    case AccessStatus.loanWaiverConfirmRequired:
      return (
        <LoanWaiverLimitView
          isMyContent={isCompact}
          quota={articlePermissions.quota}
          onConfirm={() => {
            setConfirmLoanWaiver?.(true);
            setConfirmQuotaUse?.(true);
          }}
          isInArticlePage
        />
      );
    case AccessStatus.privateAccessRequired:
    case AccessStatus.subscriptionRequired: {
      const articleContent = <LockedArticleContent inlineContent articlePermissions={articlePermissions} />;
      return <LockedContentView title={getHeaderTitle(articlePermissions.accessStatus)} content={articleContent} />;
    }
    case AccessStatus.quotaExceeded:
    case AccessStatus.quotaUsageConfirmRequired:
      if (!articlePermissions.quota) {
        return null;
      }
      return (
        <ArticleLimitView
          isMyContent={isCompact}
          onConfirm={() => setConfirmQuotaUse?.(true)}
          {...articlePermissions.quota}
        />
      );
    default:
      return null;
  }
};

export default RestrictedArticleView;
